var StudentListDropdownDisplay = require("components/org/StudentListDropdownDisplay");

require("data/student_selector_sidebar.scss");

class StudentSelectorSidebar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var activeStudentList = _.isEmpty(props.activeStudentList) ? $wr.sortByName(props.studentLists, "studentList")[0] : props.activeStudentList;
		var activeStudent = props.activeStudent === null ? $wr.sortByName(activeStudentList.students, "flexName")[0] : props.activeStudent;
		this.state = {
			activeStudentList: activeStudentList, activeStudent: activeStudent
		};
	}

	studentListChange(studentList) {
		var activeStudent = $wr.sortByName(studentList.students, "flexName")[0];
		this.setState({ activeStudentList: studentList, activeStudent: activeStudent }, function() {
			this.props.onStudentListChange(studentList);
			this.props.onStudentChange(activeStudent);
		});
	}

	studentChange(student) {
		this.setState({ activeStudent: student },
			this.props.onStudentChange(student)
		);
	}

	render() {
		var sortedStudentLists = $wr.sortByName(this.props.studentLists, "studentList");
		var studentListDropdown = (
			<StudentListDropdownDisplay dropdownDisplay={ "link" }
				studentLists={ sortedStudentLists } 
				currentStudentList={ this.state.activeStudentList }
				onChange={ this.studentListChange } displayType={ "mixed" } />
		); 
		var students = $wr.sortByName(this.state.activeStudentList.students, "flexName");
		var studentLinks = students.map(function(student) {
			var studentLinkClass = "studentRow ellipsisText";
			if (student.id == this.state.activeStudent.id && !this.props.showPaywallModal) {
				studentLinkClass += " selectedStudent";
			}
			return (
				<a className={ studentLinkClass } key={ student.id } href="#"
					onClick={ this.studentChange.bind(this, student) }>
					{ student.display_name }
				</a>
			)
		}.bind(this));

		return (
			<div className="studentSelectorSidebar">
				{ studentListDropdown }
				{ studentLinks }
			</div>
		);
	}
}

StudentSelectorSidebar.propTypes = StrictPropTypes({
	// array of student lists, must include students
	studentLists: PropTypes.array.isRequired,

	// function to call when selected student list changes
	onStudentListChange: PropTypes.func.isRequired,

	// function to call when a student is clicked
	onStudentChange: PropTypes.func.isRequired,

	// optionally, can set which student list and student are active
	activeStudentList: PropTypes.object,
	activeStudent: PropTypes.object,

	showPaywallModal: PropTypes.bool,
});

module.exports = StudentSelectorSidebar;


// WEBPACK FOOTER //
// ./modules/components/data/StudentSelectorSidebar.js